import { render } from "./app.vue?vue&type=template&id=60f0b950&ts=true"
import script from "./app.component.ts?vue&type=script&lang=ts&external"
export * from "./app.component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__